import { render, staticRenderFns } from "./ScaniaInstantaneousDataMenu.vue?vue&type=template&id=25fc81fc&"
import script from "./ScaniaInstantaneousDataMenu.vue?vue&type=script&lang=js&"
export * from "./ScaniaInstantaneousDataMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports